export const environment = {
    production: false,
    apiUrl: 'https://medeaseadmin.onetikk.org/api',
    isHospitalApp: false,
    hospitalId: ''
    // hospitalId: 'eyJpdiI6Im1jN3dpM1BOSnhXcVJhZ2VRa1dTcWc9PSIsInZhbHVlIjoid1NHZG8vUDFMUG5ScEplMU8vSUtNdz09IiwibWFjIjoiMjdkM2Y4ZmYyZGE5YzViYjA3ODczYzY3YTA4YTI2YTc2NDAzODRkZTMwOWY0ODdiNzNiNmY0Njk3ODU0MDE5MCIsInRhZyI6IiJ9'
};